import * as yup from 'yup';

const envSchema = yup.object({
  API_URL: yup.string().url().required(),
  WEB_URL: yup.string().url().required(),
  WEB_DOMAIN: yup.string().required(),
});

export const ENV = envSchema.validateSync({
  API_URL: process.env.REACT_APP_API_ENGINE_URL,
  WEB_URL: process.env.REACT_APP_WEB_URL,
  WEB_DOMAIN: process.env.REACT_APP_WEB_URL?.replace(/^https?:\/\//, ''),
});
